<template>
    <section class="home">
        <template v-for="(moduleItem, index) in sections" :key="index">
            <ModuleMenu v-if="moduleItem.type === 'BLOCK-MENU'" :module="moduleItem"></ModuleMenu>
            <ModuleDriver v-if="moduleItem.type === 'BLOCK-DRIVER'" :module="moduleItem"></ModuleDriver>
            <!-- <ModuleStarter v-if="moduleItem.type === 'BLOCK-STARTER'" :module="moduleItem"></ModuleStarter> -->
            <ModuleAlternating v-if="moduleItem.type === 'BLOCK-ALTERNATING'" :module="moduleItem"></ModuleAlternating>
            <ModuleBannerHomepage v-if="moduleItem.type === 'BLOCK-BANNER'" :module="moduleItem"/>
        </template>
    </section>
</template>

<script>
import ModuleDriver from "../components/modules/ModuleDriver.vue";
import ModuleMenu from "../components/modules/ModuleMenu.vue";
// import ModuleStarter from "../components/modules/ModuleStarter.vue";
import ModuleAlternating from "../components/modules/ModuleAlternating.vue";
import ModuleBannerHomepage from "../components/modules/ModuleBannerHomepage.vue";
import { useStore } from 'vuex';
import { computed, ref, watch } from 'vue';
import { useMeta } from 'vue-meta'

export default {
    name: "Home",
    components: {
        ModuleDriver,
        ModuleMenu,
        // ModuleStarter,
        ModuleAlternating,
        ModuleBannerHomepage
    },
    computed: {
        sections() {
            return this.$store.getters.getSectionsData;
        },
        gemiusIdentifier() {
            return this.$store.getters.getGemiusIdentifier;
        },
        history() {
            return this.$store.getters.getHistory;
        },
    },
    methods: {
        getHomesIds() {
            this.$store.dispatch("getHomeIds");
        }
    },
    mounted() {
        this.$store.dispatch("clearSectionData");
        this.getHomesIds();

        window.gemius_event(
            '_view_',
            this.gemiusIdentifier
        );


        const store = useStore();
        let id;

        if(this.$route.params.id) {
            id = parseInt(this.$route.params.id);
        } else {
            if(this.history.some(el => el.path === this.path)) {
                id = this.history.find(el => el.path === this.path).id;
            } else {
                id = window.__pageSettings.id;
            }
        }

        store.dispatch('getMeta', { id: id });
        const metaData = computed(() => store.getters.getMetaData);
        const meta_title = ref(null);
        const meta_description = ref(null);
        const meta_keywords = ref(null);
        const meta_url = ref(null);

        watch(
            () => metaData.value,
            (newValue) => {
                if (newValue && newValue.data) {
                    meta_keywords.value = newValue.data.meta_keywords;
                    meta_title.value = newValue.data.meta_title;
                    meta_description.value = newValue.data.meta_description;
                    meta_url.value = newValue.data.url
                }
            }
        );
        
        const computedMeta = computed(() => ({
            title: meta_title.value ? meta_title.value : '',
            description: meta_description.value ? meta_description.value : '',
            link: [
                {
                    rel: 'canonical',
                    href: meta_url.value ? meta_url.value : '',
                },
            ],
            meta: [
              { property: 'keywords', content: meta_keywords.value ? meta_keywords.value : '' },
            ]
        }))

        useMeta(computedMeta);
    }
}
</script>
